import Vue from 'vue';
import { GlobalState } from '../global-state/global-state';
import { AddToSamplesButton } from './product-samples/add-to-samples-button-component';
import ProductSamplesClass from '../components/product-samples/product-samples';

export default () => {
  const heroBannerWrappers = document.querySelectorAll('.home-banner__wrapper');
  if (!heroBannerWrappers) {
    return false;
  }

  heroBannerWrappers &&
    heroBannerWrappers.forEach((element) => {
      const heroSliderID = element.getAttribute('id');
      const containsSampleProductCTA = element.querySelector(
        '[js-contains-sample-cta]'
      );

      if (containsSampleProductCTA) {
        new Vue({
          el: `#${heroSliderID}`,
          components: {
            'add-to-samples': AddToSamplesButton,
          },
          data: {
            sharedState: GlobalState.state,
            productSampleClass: null,
          },
          beforeMount() {
            this.productSampleClass = new ProductSamplesClass(this);
          },
          mounted() {},
          methods: {
            ctaButtonIsEnabled(event) {
              // This method needs to be here to prevent Vue js throwing an error from the 'cta-button' snippet
            },
          },
        });
      }
    });
};
